import {
  TriggerPriceConditionGTELast,
  TriggerPriceConditionGTEMark,
  TriggerPriceConditionLTELast,
  TriggerPriceConditionLTEMark,
} from '@/api/spec';

/**
 * Classify a trigger condition by GTE/LTE direction, treating last- and mark-price variants
 * uniformly — only direction matters for TP/SL classification and "above"/"below" display.
 */
export function isGteTriggerCondition(condition: number | undefined): boolean {
  return condition === TriggerPriceConditionGTELast || condition === TriggerPriceConditionGTEMark;
}

export function isLteTriggerCondition(condition: number | undefined): boolean {
  return condition === TriggerPriceConditionLTELast || condition === TriggerPriceConditionLTEMark;
}

/** Which reference price the condition watches — mark for the *Mark variants, last otherwise. */
export function isMarkTriggerCondition(condition: number | undefined): boolean {
  return condition === TriggerPriceConditionGTEMark || condition === TriggerPriceConditionLTEMark;
}

/**
 * Direction a trigger order fires relative to its price, for "Price above/below" display.
 * Prefers the explicit condition; falls back to order-type + side when no condition is set
 * (legacy/derived orders): stop orders fire in the side's direction, TP/SL orders against it.
 */
export function triggerConditionDirection(
  condition: number | undefined,
  orderType: string | undefined,
  side: string | undefined
): 'above' | 'below' | '' {
  if (isGteTriggerCondition(condition)) return 'above';
  if (isLteTriggerCondition(condition)) return 'below';
  if (orderType === 'stopLimit' || orderType === 'stopMarket') return side === 'long' ? 'above' : 'below';
  return side === 'long' ? 'below' : 'above';
}
